import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // List
  getEventCategoryListApiData,
  getEventCategoryListApiSuccess,
  getEventCategoryListApiFailed,

  // Details
  getEventCategoryDetailsApiData,
  getEventCategoryDetailsApiSuccess,
  getEventCategoryDetailsApiFailed,

  // Add
  addEventCategoryApiData,
  addEventCategoryApiSuccess,
  addEventCategoryApiFailed,

  // Update
  updateEventCategoryApiData,
  updateEventCategoryApiSuccess,
  updateEventCategoryApiFailed,

  // Active / Inactive
  activeInactiveEventCategoryApiData,
  activeInactiveEventCategoryApiSuccess,
  activeInactiveEventCategoryApiFailed,
  getEventSubCategoryListApiData,
  getEventSubCategoryListApiSuccess,
  getEventSubCategoryListApiFailed,
  addEventSubCategoryApiData,
  addEventSubCategoryApiSuccess,
  addEventSubCategoryApiFailed,
  updateEventSubCategoryApiData,
  updateEventSubCategoryApiSuccess,
  updateEventSubCategoryApiFailed,
  activeInactiveEventSubCategoryApiData,
  activeInactiveEventSubCategoryApiSuccess,
  activeInactiveEventSubCategoryApiFailed,
  getEventSubCategoryDetailsApiData,
  getEventSubCategoryDetailsApiSuccess,
  getEventSubCategoryDetailsApiFailed,
  getEventListApiData,
  getEventListApiSuccess,
  getEventListApiFailed,
  getEventDetailsApiData,
  getEventDetailsApiSuccess,
  getEventDetailsApiFailed,
  getEventRegisterUserListApiData,
  getEventRegisterUserListApiSuccess,
  getEventRegisterUserListApiFailed,
  updateEventApiData,
  updateEventApiSuccess,
  updateEventApiFailed,
  activeInactiveEventApiData,
  activeInactiveEventApiSuccess,
  activeInactiveEventApiFailed,
} from './slice'

import { API } from '../../services'

// List
function* getEventCategoryListApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.getEventCategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(getEventCategoryListApiSuccess(response.data))
    } else {
      yield put(getEventCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEventCategoryListApiFailed({ message: error.message }))
  }
}

// Details
function* getEventCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.getEventCategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getEventCategoryDetailsApiSuccess(response.data))
    } else {
      yield put(getEventCategoryDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEventCategoryDetailsApiFailed({ message: error.message }))
  }
}

// Add
function* addEventCategoryApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.addEventCategory, payload)
    if (response.data && response.status === 200) {
      yield put(addEventCategoryApiSuccess(response.data))
    } else {
      yield put(addEventCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addEventCategoryApiFailed({ message: error.message }))
  }
}

// Update
function* updateEventCategoryApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.updateEventCategory, payload)
    if (response.data && response.status === 200) {
      yield put(updateEventCategoryApiSuccess(response.data))
    } else {
      yield put(updateEventCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateEventCategoryApiFailed({ message: error.message }))
  }
}

// Active / Inactive
function* activeInactiveEventCategoryApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.activeInactiveEventCategory, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveEventCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveEventCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveEventCategoryApiFailed({ message: error.message }))
  }
}

// -------- Event List --------
function* getEventListApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.getEventList, payload)
    if (response.data && response.status === 200) {
      yield put(getEventListApiSuccess(response.data))
    } else {
      yield put(getEventListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEventListApiFailed({ message: error.message }))
  }
}

// -------- Event Details --------
function* getEventDetailsApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.getEventDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getEventDetailsApiSuccess(response.data))
    } else {
      yield put(getEventDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEventDetailsApiFailed({ message: error.message }))
  }
}

function* getEventRegisterUserListApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.getEventRegisterUserList, payload)
    if (response.data && response.status === 200) {
      yield put(getEventRegisterUserListApiSuccess(response.data))
    } else {
      yield put(getEventRegisterUserListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEventRegisterUserListApiFailed({ message: error.message }))
  }
}

// Update Event
function* updateEventApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.updateEvent, payload)
    if (response.data && response.status === 200) {
      yield put(updateEventApiSuccess(response.data))
    } else {
      yield put(updateEventApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateEventApiFailed({ message: error.message }))
  }
}

// Active / Inactive Event
function* activeInactiveEventApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.activeInactiveEvent, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveEventApiSuccess(response.data))
    } else {
      yield put(activeInactiveEventApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveEventApiFailed({ message: error.message }))
  }
}

// -------- Event Sub Category List --------
function* getEventSubCategoryListApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.getEventSubCategoryList, payload)

    if (response.data && response.status === 200) {
      yield put(getEventSubCategoryListApiSuccess(response.data))
    } else {
      yield put(
        getEventSubCategoryListApiFailed({
          message: response?.message || 'Failed to fetch subcategories',
        }),
      )
    }
  } catch (error) {
    yield put(
      getEventSubCategoryListApiFailed({
        message: error.message,
      }),
    )
  }
}

function* addEventSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.addEventSubCategory, payload)

    if (response.data && response.status === 200) {
      yield put(addEventSubCategoryApiSuccess(response.data))
    } else {
      yield put(
        addEventSubCategoryApiFailed({
          message: response?.message || 'Failed to add subcategory',
        }),
      )
    }
  } catch (error) {
    yield put(
      addEventSubCategoryApiFailed({
        message: error.message,
      }),
    )
  }
}

function* updateEventSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.updateEventSubCategory, payload)

    if (response.data && response.status === 200) {
      yield put(updateEventSubCategoryApiSuccess(response.data))
    } else {
      yield put(
        updateEventSubCategoryApiFailed({
          message: response?.message || 'Failed to update subcategory',
        }),
      )
    }
  } catch (error) {
    yield put(
      updateEventSubCategoryApiFailed({
        message: error.message,
      }),
    )
  }
}

function* activeInactiveEventSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.activeInactiveEventSubCategory, payload)

    if (response.data && response.status === 200) {
      yield put(activeInactiveEventSubCategoryApiSuccess(response.data))
    } else {
      yield put(
        activeInactiveEventSubCategoryApiFailed({
          message: response?.message || 'Failed to update status',
        }),
      )
    }
  } catch (error) {
    yield put(
      activeInactiveEventSubCategoryApiFailed({
        message: error.message,
      }),
    )
  }
}

// -------- Event Sub Category Details --------
function* getEventSubCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.eventManagement.getEventSubCategoryDetails, payload)

    if (response.data && response.status === 200) {
      yield put(getEventSubCategoryDetailsApiSuccess(response.data))
    } else {
      yield put(
        getEventSubCategoryDetailsApiFailed({
          message: response?.message || 'Failed to fetch event subcategory details',
        }),
      )
    }
  } catch (error) {
    yield put(
      getEventSubCategoryDetailsApiFailed({
        message: error.message,
      }),
    )
  }
}

export default function* eventCategorySaga() {
  yield takeEvery(getEventCategoryListApiData.type, getEventCategoryListApi)
  yield takeEvery(getEventCategoryDetailsApiData.type, getEventCategoryDetailsApi)
  yield takeEvery(addEventCategoryApiData.type, addEventCategoryApi)
  yield takeEvery(updateEventCategoryApiData.type, updateEventCategoryApi)
  yield takeEvery(getEventListApiData.type, getEventListApi)
  yield takeEvery(getEventDetailsApiData.type, getEventDetailsApi)
  yield takeEvery(activeInactiveEventCategoryApiData.type, activeInactiveEventCategoryApi)
  yield takeEvery(getEventRegisterUserListApiData.type, getEventRegisterUserListApi)
  yield takeEvery(updateEventApiData.type, updateEventApi)
  yield takeEvery(activeInactiveEventApiData.type, activeInactiveEventApi)
  yield takeEvery(getEventSubCategoryListApiData.type, getEventSubCategoryListApi)
  yield takeEvery(addEventSubCategoryApiData.type, addEventSubCategoryApi)
  yield takeEvery(updateEventSubCategoryApiData.type, updateEventSubCategoryApi)
  yield takeEvery(activeInactiveEventSubCategoryApiData.type, activeInactiveEventSubCategoryApi)
  yield takeEvery(getEventSubCategoryDetailsApiData.type, getEventSubCategoryDetailsApi)
}
